const ACCESS_ROLES = {
  DISABLED: 0,
  USER: 10,
  MANAGER: 20,
  ADMIN: 30
};

class MitUserModel{
    constructor(csailId, fname, lname, access, csailEmail){
        this.user = {
          csailId: csailId,
          fname: fname,
          lname: lname,
          role: access,
          email:csailEmail
        };
    }
    get(){
      return this.user;
    }
}

MitUserModel.ROLES = ACCESS_ROLES;

export default MitUserModel;
